import { ProjectVisibility, UserPinType } from '../enums';
import { simplePath } from '../utils';

export const GET_USER_PINS_PATH = '/v2/pins/user/:user';
export const GET_APPLICATION_LIST_PINS_PATH = `/v2/user-pin/:user/pinned-applications`;

export interface GetUserPinsParams {
  user: string;
}

export function get_user_pins_path(params: GetUserPinsParams) {
  return simplePath(GET_USER_PINS_PATH, params);
}

export interface GetApplicationLPinsParams {
  user: string;
}

export function get_application_list_pins_path(params: GetApplicationLPinsParams) {
  return simplePath(GET_APPLICATION_LIST_PINS_PATH, params);
}

export interface PinProject {
  id: string;
  name: string;
  counters: {
    applications: number;
    remotes: number;
  };
  description: string;
  visibility: ProjectVisibility;
}

export interface PinOrganization {
  id: string;
  name: string;
  cloudHost: string;
}

export interface PinApplication {
  id: string;
  name: string;
}

interface PinBase {
  type: UserPinType;
  project: PinProject;
  organization: PinOrganization;
  application?: PinApplication;
}

export interface ProjectPin extends PinBase {
  type: (typeof UserPinType)['Project'];
  application?: undefined;
}

export interface ApplicationPin extends PinBase {
  type: (typeof UserPinType)['Application'];
  application: PinApplication;
}

export type Pin = ProjectPin | ApplicationPin;
